import {
	httpClient,
	getAgencyKey,
	getCurrentLanguage,
	getApplicationHeaders,
} from "@utils";

import { OfferService } from "@gp/hub";

import {
	MenuResponse,
	PrematchMenuApiFilter,
} from "@api-types/offer/PrematchMenuResponse";

class PrematchOfferApiService extends OfferService {
	constructor() {
		super({
			apiClient: {
				get: async (relativeUrl: string) => {
					const url = `${WEBPACK_BASE_PROXY_ADDRESS}${getAgencyKey()}/${relativeUrl}`;
					const response = await httpClient.get(
						url,
						this.getRequestHeaders()
					);
					return await response.json();
				},
			},
			callerEnvironment: WEBPACK_ENVIRONMENT_KEY,
			getLanguage: () => getCurrentLanguage(),
		});
	}

	async getPrematchMenu<K extends PrematchMenuApiFilter>(
		filter: K
	): Promise<MenuResponse<K>> {
		return this.getSportsMenu(filter);
	}

	private getRequestHeaders = () => {
		const appHeaders = getApplicationHeaders();
		// @ts-expect-error
		appHeaders["Content-Type"] = "application/json";
		return appHeaders;
	};
}

export default new PrematchOfferApiService();
